import { BTRDLProductForm } from "../BTRDLProductForm";

export interface AddBTRDLProductProps {}

export const AddBTRDLProduct = () => {
  return <BTRDLProductForm />;
};
